import { render } from "./Tutorial.vue?vue&type=template&id=4c1c6c8e&scoped=true&ts=true"
import script from "./Tutorial.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tutorial.vue?vue&type=script&setup=true&lang=ts"

import "./Tutorial.vue?vue&type=style&index=0&id=4c1c6c8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1c6c8e"],['__file',"src/components/Tutorial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c1c6c8e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c1c6c8e', __exports__)) {
    api.reload('4c1c6c8e', __exports__)
  }
  
  module.hot.accept("./Tutorial.vue?vue&type=template&id=4c1c6c8e&scoped=true&ts=true", () => {
    api.rerender('4c1c6c8e', render)
  })

}


export default __exports__